import { useContext } from "react";
import { AdminSideBarCtx } from "./AdminSideBarCtx.ts";

export function useAdminSidebarCtx() {
  return useContext(AdminSideBarCtx);
}
